import { render, staticRenderFns } from "./StockStatusDescription.vue?vue&type=template&id=c43a64d2"
import script from "./StockStatusDescription.vue?vue&type=script&lang=js"
export * from "./StockStatusDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports